import { BranchLinkOptions } from '../branchLinkConfiguration';
import { Nullable } from '@/scripts/models/utility-types';

export const generateBranchShortLink = (options: BranchLinkOptions): Promise<string> => (
  new Promise((resolve, reject) => {
    window.branch.link(options, (error: Nullable<Error>, link: string) => {
      if (error) {
        return reject(error);
      }
      resolve(link);
    });
  })
);
